import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import RelatedGifts from '../../RelatedGifts';
import { useSelector } from 'react-redux';
import { SiteSettingsContext } from '../../../utils/context';
import { getRelatedProductsForGift } from '../../../utils/Gifts/transforms.gifts.data';
import { CategoriesContext } from '../../../utils/context';

import styles from './index.module.scss';

const BBRelatedProducts = ({ items, productId }) => {
  const products = useSelector((state) => state.productsStorage.gifts);
  const categories = useContext(CategoriesContext);
  const allGiftsCategory = Object.values(categories).find((item) => item.title === 'All gifts');
  const allGiftsCategoryId = allGiftsCategory ? allGiftsCategory.id : 0;
  const settings = useContext(SiteSettingsContext);
  const countItems = 3;
  // The products will be rendered on the Server side.
  const relatedGiftsConfigured = [];
  items.forEach((id) => {
    if (products[id]) {
      relatedGiftsConfigured.push(id);
    }
  });
  const [relatedGifts, setRelatedGifts] = useState(relatedGiftsConfigured);

  useEffect(() => {
    if (relatedGiftsConfigured.length < countItems) {
      const relatedGiftsWithRandom = getRelatedProductsForGift(
        products[productId],
        products,
        items,
        allGiftsCategoryId,
        countItems,
      );
      setRelatedGifts(relatedGiftsWithRandom);
    }
  }, [productId]);

  if (!relatedGifts.length) {
    return null;
  }

  return (
    <div className={`bb ${styles['bb-related-products']}`}>
      <div className={'container'}>
        <RelatedGifts
          title={settings.giftDetailPage.relatedGiftsTitle || 'You might also like'}
          productIds={relatedGifts}
        />
      </div>
    </div>
  );
};

BBRelatedProducts.propTypes = {
  items: PropTypes.array.isRequired,
  productId: PropTypes.number.isRequired,
};

export default BBRelatedProducts;
